export default {
    SOLAR_HOST: 'https://xyst.yuanfudao.com',
    LEO_HOST: 'https://xyks.yuanfudao.com',
    GALLERY_HOST: 'https://gallery.fbcontent.cn/api/ape/images/',
    APE_HOST: 'https://ytk.yuanfudao.com'
};
